import { useSelector } from 'react-redux';

import type { RootState } from '../../../../../../store';

export default function useTreatmentPlanV3AssessmentPageState() {
  const assessmentPage = useSelector((state: RootState) => state.treatmentPlanV3.assessmentPage);
  const behaviors = assessmentPage?.behaviors ?? [];
  const methods = assessmentPage?.methods ?? [];
  const noMaladaptiveBehavior = assessmentPage?.no_maladaptive_behavior ?? false;
  const hasTemplatesSettled = useSelector(
    (state: RootState) =>
      state.treatmentPlanV3.assessmentTemplates != null ||
      state.treatmentPlanV3.assessmentTemplatesError != null,
  );
  const hasLoaded = assessmentPage !== null && hasTemplatesSettled;
  const hasLoadError = useSelector(
    (state: RootState) => state.treatmentPlanV3.assessmentPageError != null,
  );
  const assessmentPageLoading = useSelector(
    (state: RootState) => state.treatmentPlanV3.assessmentPageLoading,
  );
  const isLoading = assessmentPageLoading || (!hasLoaded && !hasLoadError);
  const isBulkSaving = useSelector(
    (state: RootState) => state.treatmentPlanV3.updateAssessmentPageLoading,
  );
  const isSaving = useSelector(
    (state: RootState) =>
      state.treatmentPlanV3.createAssessmentBehaviorLoading ||
      state.treatmentPlanV3.updateAssessmentBehaviorLoading ||
      state.treatmentPlanV3.deleteAssessmentBehaviorLoading ||
      state.treatmentPlanV3.updateAssessmentPageLoading,
  );
  const templates = useSelector((state: RootState) => state.treatmentPlanV3.assessmentTemplates);
  const isSavingMethods = useSelector(
    (state: RootState) =>
      state.treatmentPlanV3.createAssessmentMethodLoading ||
      state.treatmentPlanV3.updateAssessmentMethodLoading ||
      state.treatmentPlanV3.deleteAssessmentMethodLoading ||
      state.treatmentPlanV3.createAssessmentMethodVisualsLoading ||
      state.treatmentPlanV3.updateAssessmentMethodVisualLoading ||
      state.treatmentPlanV3.updateAssessmentMethodVisualFileLoading ||
      state.treatmentPlanV3.deleteAssessmentMethodVisualLoading,
  );
  const isSavingReadiness = useSelector(
    (state: RootState) => state.treatmentPlanV3.updateAssessmentReadinessItemLoading,
  );

  return {
    assessmentPage,
    behaviors,
    methods,
    noMaladaptiveBehavior,
    templates,
    isLoading,
    hasLoaded,
    hasLoadError,
    isSaving,
    isSavingMethods,
    isSavingReadiness,
    isBulkSaving,
  };
}
